import {
  type WorkflowDefinition,
  WorkflowNodeType,
  type WorkflowStepCatalog,
} from './workflow-definition';
import { summarizeStep } from './workflow-step-summary';

/** The step-type filter value for conditions (`if` steps), next to the catalog's own types. */
export const CONDITIONS_FILTER = 'conditions';

export interface WorkflowSearch {
  /** Text to find in a step's name, its card line or its settings; empty matches any. */
  query: string;
  /** A step type, `CONDITIONS_FILTER`, or empty for any step. */
  stepType: string;
}

/**
 * The steps that match a search, in stored order — which keeps close to the order on the canvas.
 * An empty search matches nothing, so nothing is highlighted until something is typed or picked.
 */
export function findSearchMatches(
  definition: WorkflowDefinition,
  catalog: WorkflowStepCatalog,
  { query, stepType }: WorkflowSearch,
): string[] {
  const text = query.trim().toLowerCase();
  if (!text && !stepType) return [];

  return definition.nodes
    .filter((node) => {
      if (stepType === CONDITIONS_FILTER && node.type !== WorkflowNodeType.If) return false;
      if (stepType && stepType !== CONDITIONS_FILTER && node.type !== stepType) return false;
      if (!text) return true;

      const type = catalog.byType.get(node.type);
      return [
        type?.label ?? node.type,
        summarizeStep(node, type),
        JSON.stringify(node.data ?? {}),
      ]
        .join(' ')
        .toLowerCase()
        .includes(text);
    })
    .map(({ id }) => id);
}
